import { AvailableTile } from "./AvailableTile";
import { CapTile } from "./CapTile";
import { TileSkeleton } from "./Tile";
import { TopUpTile } from "./TopUpTile";
import type { CaptainBillingAccount } from "../../types";

export type CaptainBillingEditor = "cap" | "topUp" | "correct";

export const TOP_UP_TILE_ID = "captain-billing-top-up";

type CaptainBillingTilesProps = {
  account?: CaptainBillingAccount;
  isLoading: boolean;
  canManage: boolean;
  editor: CaptainBillingEditor | null;
  onEditorChange: (editor: CaptainBillingEditor | null) => void;
};

export function CaptainBillingTiles({ account, isLoading, canManage, editor, onEditorChange }: CaptainBillingTilesProps) {
  if (isLoading || !account)
    return (
      <div className={TILE_GRID} data-testid="captain-billing-tiles-loading">
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
      </div>
    );

  const editorProps = (name: CaptainBillingEditor) =>
    canManage
      ? { isEditing: editor === name, onEdit: () => onEditorChange(name), onDone: () => onEditorChange(null) }
      : undefined;

  return (
    <div className={TILE_GRID}>
      <AvailableTile account={account} edit={editorProps("correct")} />
      <CapTile account={account} edit={editorProps("cap")} />
      <TopUpTile account={account} edit={editorProps("topUp")} />
    </div>
  );
}

const TILE_GRID = "grid grid-cols-1 gap-4 lg:grid-cols-3";